import type { GetResourceBySlugQueryResult } from "@/sanity.types";

import { SuggestedForYouItems } from "./suggestedForYouItems.component";

export const SuggestedForYouBlock = ({ block }: SuggestedForYouBlockProps) => {
  if (!block?.recommendations?.length) return null;

  return (
    <SuggestedForYouItems
      products={block.recommendations}
      title={block.title ?? undefined}
    />
  );
};

type PageBuilderBlock = NonNullable<
  NonNullable<GetResourceBySlugQueryResult>["pageBuilder"]
>[number];

export type SuggestedForYouPageBlock = Extract<
  PageBuilderBlock,
  { _type: "suggestedForYou" }
>;

export type SuggestedForYouBlockProps = {
  block: SuggestedForYouPageBlock;
};
